import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeModel } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'model';

export const modelSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeModel(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeModel }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeModel } = modelSlice.actions;

export const model = modelSlice.reducer;
